import { render } from "./AllowGeolocationView.vue?vue&type=template&id=4f4e823b"
import script from "./AllowGeolocationView.vue?vue&type=script&lang=js"
export * from "./AllowGeolocationView.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/cgeolink/src/front/cgeolink/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__